import axios from 'axios';
import localStorage from '../../utils/localStorage';
import { API_TRENDS } from '../../commons/api';

export function getGraphData(payload) {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const getProcessArea = {
    method: 'POST',
    url: `${API_TRENDS.LIST}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: payload
  };
  return axios(getProcessArea)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
}
